import { useTranslation } from "react-i18next";
import { useForm } from "react-hook-form";
import { Text, useToast } from "@chakra-ui/react";
import { organizationQuestionnaireKeys } from "../../../../../../hooks/query";
import { FormInput } from "components/Forms";
import { useQueryClient } from "react-query";
import CategoryForm from "./CategoryForm";
import { useCreateFranchisesCategory, useUpdateFranchisesCategory } from "hooks/query/scope-3";
import { showErrorToast, showSuccessToast, translateSubElementString } from "../../../../../../utils";

function CategoryFranchise({ defaultValues, handleCategoryChange, tabKey, finalize, finalizeQuestionnaire }) {
  const toast = useToast();
  const queryClient = useQueryClient();
  const {
    id: questionnaireId,
    categories: {
      franchises: {
        co2Emission, id: categoryId
      } = {
        id: null,
        co2Emission: null
      }
    }
  } = defaultValues;
  const { t } = useTranslation("translation", {
    keyPrefix: "organizationQuestionnaire.scope3",
  });

  const franchiseDefaultValues = {
    co2Emission: co2Emission ?? "",
  };

  const {
    register,
    handleSubmit,
    formState: { errors, isDirty },
  } = useForm({
    defaultValues: franchiseDefaultValues,
  });

  const formId = `formStep${tabKey}`;

  const queryConfig = {
    onSuccess: () => {
      showSuccessToast(toast, "Category Franchise saved!");
      if (finalize) {
        finalizeQuestionnaire(questionnaireId);
      } else {
        queryClient.invalidateQueries(organizationQuestionnaireKeys.orgQuestionnaireById());
        if (!isLoadingOnCreate && !isLoadingOnUpdate) {
          handleCategoryChange();
        }
      }
    },
    onError: err => {
      showErrorToast(toast, err.message);
    }
  };

  const { mutate: create, isLoading: isLoadingOnCreate } = useCreateFranchisesCategory(queryConfig);
  const { mutate: update, isLoading: isLoadingOnUpdate } = useUpdateFranchisesCategory(queryConfig);

  const onSubmit = ((data) => {
    if (isDirty) {
      categoryId
        ? update({ questionnaireId, id: categoryId, data })
        : create({ questionnaireId, data });
    } else {
      finalize ? finalizeQuestionnaire(questionnaireId) : handleCategoryChange();
    }
  });

  return (
    <CategoryForm onSubmit={handleSubmit((data) => onSubmit({ data }))} id={formId}>
      <Text opacity="0.75" fontSize="sm" marginBlockEnd="4">
        {t(`categories.${tabKey}Desc`)}
      </Text>
      <FormInput
        label={translateSubElementString(`organizationQuestionnaire.scope3.inputs.tCO2e`)}
        type="number"
        errors={errors}
        {...register("co2Emission")}
        isDisabled={true}
      />
    </CategoryForm>
  );
}

export default CategoryFranchise;

